import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';
import profile from './imgs/profile.jpg';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class About extends Component {
  render() {
    return (
      <div className="App-body">
        <div className="App-body-bio">
          <h1>hi, i'm meredith.</h1>
          <h2>engineer • designer • writer • creator.</h2>
          <div className="App-body-bio-text">
            <p>I'm a software engineer at Lawrence Livermore and
            a Ph.D. student in Computer Science at UC Davis. My research
            interests include HCI and visual computing, specifically engineering
            seamless immersive user experiences and improving their usability.
            At Davis, I'm currently working in the Collaborative and Social
            Computing Lab (CSC Lab) with&nbsp;
            <a href="http://www.haochuanwang.info/" target="_blank"
            rel="noopener noreferrer">Hao-Chuan Wang</a>. Previously, I've
            worked on wearable form factors for electrochemical biosensors
            with&nbsp;<a href="https://katiavega.com/" target="_blank"
            rel="noopener noreferrer">Katia Vega</a>.</p>
            <br />
            <p>I graduated with a M.S. (Computer Science) from Brown University
            in 2021, where I did AR/VR research with&nbsp;
            <a href="https://jeffhuang.com/" target="_blank"
            rel="noopener noreferrer">Jeff Huang</a> and&nbsp;
            <a href="https://jamestompkin.com"
            target="_blank" rel="noopener noreferrer">James Tompkin</a>, and
            with a B.S. (Computer Science) and a minor in Information Science
            from Cornell University in 2019, where I did research on textile
            simulation tools with&nbsp;
            <a href="https://www.cs.cornell.edu/~srm/" target="_blank"
            rel="noopener noreferrer">Steve Marschner</a> and&nbsp;
            <a href="https://www.cs.cornell.edu/~francois/" target="_blank"
            rel="noopener noreferrer">François Guimbretière</a>.
            My other experience includes working on computer vision-related deep
            learning research as an intern at GE Research in the
            Software & Analytics Group (Summer '20). When I’m not coding or
            doing research, you can find me&nbsp;
            <NavLink to="/music">making music</NavLink>, working
            on STEM-related diversity outreach, or reading and writing
            personal essays.</p>
          </div>
          <div className="App-body-bio-buttons">
            <NavLink className="Button-work" to="/work">work</NavLink>
            <a href={process.env.PUBLIC_URL + "./resume.pdf"} target="_blank"
            rel="noopener noreferrer" className="Button-work">resume</a>
            <a href={process.env.PUBLIC_URL + "./cv.pdf"} target="_blank"
            rel="noopener noreferrer" className="Button-resume">cv</a>
          </div>
        </div>
        <div className="App-body-pic">
          <img src={profile} alt="Profile"/>
          <div className="App-body-pic-info">
            <p><span id="App-body-status">currently</span>: swe @ llnl, uc davis cs ph.d.</p>
            <p><span id="App-body-status">previously</span>: cornell b.s. ’19, brown m.s. '21, edison intern @ ge research</p>
            <p><span id="App-body-status">future</span>: tbd</p>
          </div>
          <div className="App-body-pic-info">
            <a href="mailto: mjyoungng@ucdavis.edu">
              <FontAwesomeIcon icon={['fas', 'paper-plane']} />
            </a>
            <a href="https://github.com/MeredithYoung-Ng" target="_blank"
            rel="noopener noreferrer">
              <FontAwesomeIcon icon={['fab', 'github']} />
            </a>
            <a href="https://www.linkedin.com/in/meredith-young-ng"
            target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={['fab', 'linkedin-in']} />
            </a>
            <a href={process.env.PUBLIC_URL + "./cv.pdf"} target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={['fas', 'file']} />
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default About;
